import React from 'react';
import { useTransition } from 'react-spring';
import Overlay from '../Overlay';
import CloseIcon from '../../assets/icons/CloseIcon';
import {
  ModalContainer,
  ContentContainer,
  ButtonContainer,
  CloseButton,
} from './styles/Modal.style';

interface ModalProps {
  handleIsOpen: () => void;
  isOpen: boolean;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, handleIsOpen, children }): any | null => {
  const modalTransition = useTransition(isOpen, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 400 },
  });

  const handleStopProgagation = (e: React.MouseEvent<HTMLElement, MouseEvent>) =>
    e.stopPropagation();

  return modalTransition.map(({ item, key, props }) => {
    return item ? (
      <Overlay key={key} props={props} isOpen={isOpen} handleIsOpen={handleIsOpen} zIndex={980}>
        <ModalContainer
          key={key}
          style={props}
          aria-modal="true"
          onClick={handleStopProgagation}
          data-testid="modal-container"
        >
          <ButtonContainer>
            <CloseButton type="button" onClick={handleIsOpen} data-testid="modal-close-button">
              <CloseIcon color="black" />
            </CloseButton>
          </ButtonContainer>
          <ContentContainer>{children}</ContentContainer>
        </ModalContainer>
      </Overlay>
    ) : null;
  });
};

export default Modal;
